'use client'
import { LOGIN_URL, PC_MOBILE_BREAKPOINT } from '@/constants/global'
import { StorageKey } from '@/constants/storage'
import buffer from 'buffer'

export const getCookieValue = (cookieName: string) => {
  const cookies = typeof document !== 'undefined' ? document.cookie.split(';') : []

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim().split('=')

    if (cookie[0] === cookieName) {
      return cookie[1]
    }
  }

  return null
}

export const decodeJwt = (jwt: string): any | undefined => {
  try {
    const payload = (jwt ?? '').split('.')[1]
    return JSON.parse(buffer.Buffer.from(payload, 'base64').toString('utf8'))
  } catch {}
}

export const setPreUrlAndRedirectToLoginUrl = () => {
  if (typeof localStorage !== 'undefined' && typeof window !== 'undefined') {
    localStorage.setItem(StorageKey.PRE_URL, window.location.href)
    const loginUrl = `${LOGIN_URL}&device=${window.innerWidth < PC_MOBILE_BREAKPOINT ? 'mobile' : 'pc'}`
    window.location.replace(loginUrl)
  }
}

export const removePreUrl = () => {
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(StorageKey.PRE_URL)
  }
}

export const removeStartEndDoubleQuotes = (str: string | null) => {
  return (str || '').replaceAll('"', '')
}

// export const decodeJwtForBrowser = (jwt:string) => {
//   const payload = jwt.split('.')[1]
//   return JSON.parse(buffer.Buffer.from(payload, 'base64').toString('utf8'))
// }

export const isDesktop = () => {
  return typeof window !== 'undefined' && window.innerWidth >= PC_MOBILE_BREAKPOINT
}

export const isPreview = () => {
  if (typeof window === 'undefined') return false
  const prefix = window.location.host?.split('.')[0]
  return prefix === 'preview'
}

export const withoutHeaderFooter = () => {
  return sessionStorage.getItem(StorageKey.WO_HEADER_FOOTER) === 'true'
}

export const isFromSalesApp = () => {
  return sessionStorage.getItem(StorageKey.IS_FROM_SALES_APP) === 'true'
}

export const isFromDouYinMnp = () => {
  return sessionStorage.getItem(StorageKey.IS_FROM_DOU_YIN_MNP) === 'true'
}

export const isDisplayCTA = () => {
  return sessionStorage.getItem(StorageKey.IS_DISPLAY_CTA) === 'true'
}

export const isFromApp = () => {
  return isFromSalesApp() || isFromDouYinMnp()
}

// 判断两个一维数组有交集
export function hasIntersection<T>(array1: T[], array2: T[]): boolean {
  // 假设数组不包含重复元素，使用 Set 来优化查找性能
  const set1 = new Set(array1)

  for (const element of array2) {
    if (set1.has(element)) {
      return true
    }
  }

  return false
}

export const setBodyOverflowHidden = (direction: 'X' | 'Y' | 'Both', hidden: boolean) => {
  if (typeof document !== 'undefined') {
    const classList = document.querySelector('body')?.classList
    if (!classList) return
    switch (direction) {
      case 'X':
        if (hidden) {
          classList.add('disable-scroll-x')
        } else {
          classList.remove('disable-scroll-x')
        }
        break
      case 'Y':
        if (hidden) {
          classList.add('disable-scroll-y')
        } else {
          classList.remove('disable-scroll-y')
        }
        break
      case 'Both':
        if (hidden) {
          classList.add('disable-scroll-both')
        } else {
          classList.remove('disable-scroll-both')
        }
        break
      default:
        break
    }
  }
}

export const goToUrl = (url: string) => {
  const currentOrigin = typeof window !== 'undefined' ? window.location.origin : ''
  try {
    const targetUrl = new URL(url, currentOrigin)

    if (targetUrl.origin === currentOrigin) {
      window.open(url, '_self')
    } else {
      if (targetUrl.href) {
        window.open(targetUrl.href, '_blank')
      }
    }
  } catch (e) {
    console.error('Invalid URL:', e, url)
  }
}

/**
 * 移除所有特殊字符，只保留汉字和英文字母
 * @param str 输入的字符串
 * @returns 处理后的字符串，只包含汉字和英文字母
 */
export function removeSpecialChars(str: string): string {
  return str.replace(/[^\u4e00-\u9fa5a-zA-Z]/g, '');
}